import gsap from 'gsap';
function secondarySchoolsStrip() {
    const secondarySchoolsStrip = document.querySelectorAll('[data-block="secondary-schools-strip"]');

    if ( secondarySchoolsStrip.length > 0 ){
        secondarySchoolsStrip.forEach(secondarySchoolStrip => {
            const firstLine = secondarySchoolStrip.querySelector('.secondary-schools-strip__first-line');
            const secondLine = secondarySchoolStrip.querySelector('.secondary-schools-strip__second-line');
           
            // First line animation
            // Clone the slides to create continuous flow
            const firstLineSlides = firstLine.querySelectorAll('.marquee-slide');
            firstLineSlides.forEach(slide => {
                const clone = slide.cloneNode(true);
                firstLine.appendChild(clone);
            });

            const firstLineTotalWidth = Array.from(firstLineSlides).reduce((width, slide) => {
                return width + slide.offsetWidth;
            }, 0);

            gsap.to(firstLine, {
                x: -firstLineTotalWidth,
                duration: 50,
                ease: "none",
                repeat: -1,
                onReverseComplete: () => {
                    gsap.set(firstLine, { x: 0 });
                }
            });

            // Second line animation (opposite direction)
            // Clone the slides to create continuous flow
            const secondLineSlides = secondLine.querySelectorAll('.marquee-slide');
            secondLineSlides.forEach(slide => {
                const clone = slide.cloneNode(true);
                secondLine.appendChild(clone);
            });

            const secondLineTotalWidth = Array.from(secondLineSlides).reduce((width, slide) => {
                return width + slide.offsetWidth;
            }, 0);

            gsap.to(secondLine, {
                x: secondLineTotalWidth, // Positive value for opposite direction
                duration: 50,
                ease: "none", 
                repeat: -1,
                onReverseComplete: () => {
                    gsap.set(secondLine, { x: 0 });
                }
            });
                    
        });
    }
}

export default secondarySchoolsStrip;